<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('note_edit.title') }}</h1>
      <note-form :colony="colony" :apiary="apiary" :id="id"></note-form>
    </b-container>
  </div>
</template>

<script>
import NoteForm from '../components/NoteForm'
export default {
  name: 'NoteEdit',
  props: ['apiary', 'colony', 'id'],
  components: { NoteForm }
}
</script>

<style scoped>

</style>
